import { ReactNode } from "react";

import useIacTableStore from "views/Account/IacManagement/components/Table/useIacTableStore";
import { selectColumnSize } from "views/Account/IacManagement/components/Table/useIacTableStore/tableMetaSelectors";
import TableCellText from "ds/components/Table/Row/CellText";

import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";

type IacManagementTableTextProps = {
  children: ReactNode;
  columnId: IAC_MANAGEMENTS_TABLE_COLUMNS;
};

const IacManagementTableText = ({ children, columnId }: IacManagementTableTextProps) => {
  // force re-render when column size changes to update the text ellipsis
  useIacTableStore((state) => selectColumnSize(state, columnId));

  return <TableCellText>{children}</TableCellText>;
};

export default IacManagementTableText;
